/**
 * Утилита чтобы подготовить номер телефона под формат "+7 ··· ··· 88 88" или "+7 910 000 88 88"
 * @param phoneStr номер телефона
 * @param isFullNumber флаг, маскировать ли номер телефона
 * @returns string
 */
export const formatPhoneNumber = (phoneStr?: string, isFullNumber = false) => {
    if (!phoneStr) return;

    const latestTwoOneChars = phoneStr.slice(-2);
    const latestThreeFourChars = phoneStr.slice(-4, -2);

    if (isFullNumber) {
        const firstThreeChars = phoneStr.slice(0, 3);
        const secondThreeChars = phoneStr.slice(3, 6);

        return `+7 ${firstThreeChars} ${secondThreeChars} ${latestThreeFourChars} ${latestTwoOneChars}`;
    }

    return `+7 ··· ··· ${latestThreeFourChars} ${latestTwoOneChars}`;
};
